import React, { useState } from 'react';

const predefinedDatasets = {
  dataset1: {
    nodes: ['A', 'B', 'C', 'D'],
    edges: ['A-B-1', 'A-C-4', 'B-C-2', 'B-D-5', 'C-D-1']
  },
  dataset2: {
    nodes: ['A', 'B', 'C', 'D', 'E'],
    edges: ['A-B-2', 'A-C-4', 'B-C-1', 'B-D-7', 'C-D-3', 'D-E-1']
  }
};

function DijkstraControls({ onStart }) {
  const [nodes, setNodes] = useState('');
  const [edges, setEdges] = useState('');
  const [selectedDataset, setSelectedDataset] = useState('');

  const handleDatasetChange = (e) => {
    const dataset = predefinedDatasets[e.target.value];
    setSelectedDataset(e.target.value);
    setNodes(dataset.nodes.join(','));
    setEdges(dataset.edges.join(','));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const nodeList = nodes.split(',').map(id => ({ id: id.trim() }));
    const edgeList = edges.split(',').map(edge => {
      const [from, to, weight] = edge.split('-').map(el => el.trim());
      return { from, to, weight: parseInt(weight, 10) };
    });
    onStart({ nodes: nodeList, edges: edgeList });
  };

  return (
    <form onSubmit={handleSubmit} className="dijkstra-controls">
      <div className="form-group">
        <label>
          Choose a predefined dataset:
          <select onChange={handleDatasetChange} value={selectedDataset}>
            <option value="">Select a dataset</option>
            {Object.keys(predefinedDatasets).map(key => (
              <option key={key} value={key}>{key}</option>
            ))}
          </select>
        </label>
      </div>
      <div className="form-group">
        <label>
          Nodes (comma-separated):
          <input
            type="text"
            value={nodes}
            onChange={(e) => setNodes(e.target.value)}
          />
        </label>
      </div>
      <div className="form-group">
        <label>
          Edges (comma-separated, format: from-to-weight):
          <input
            type="text"
            value={edges}
            onChange={(e) => setEdges(e.target.value)}
          />
        </label>
      </div>
      <button type="submit">Start Dijkstra</button>
    </form>
  );
}

export default DijkstraControls;
